import {
  FETCHED_TEAM_A_MAPPING,
  FETCHED_TEAM_B_MAPPING,
  CLEAR_PLAYER_MATCH_MAPPING,
  RETURN_PLAYER_MATCH_MAPPING_ERROR,
  MATCH_MAPPING_UPDATE_INIT,
  MATCH_MAPPING_UPDATE_SUCCESS,
  MATCH_MAPPING_UPDATE_FAILED,
} from "../actions/types";

const INITIAL_STATE = {
  team_a_mapping: null,
  team_b_mapping: null,
  team_a_mapping_error: false,
  team_b_mapping_error: false,
  updating: false,
  update_result: null,
  update_error: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MATCH_MAPPING_UPDATE_INIT:
      return {
        ...state,
        updating: true,
        update_result: null,
        update_error: false,
      };
    case MATCH_MAPPING_UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        update_result: action.payload,
        update_error: false,
      };
    case MATCH_MAPPING_UPDATE_FAILED:
      return { ...state, updating: false, update_error: true };
    case FETCHED_TEAM_A_MAPPING:
      return { ...state, team_a_mapping: action.payload };
    case FETCHED_TEAM_B_MAPPING:
      return { ...state, team_b_mapping: action.payload };
    case CLEAR_PLAYER_MATCH_MAPPING:
      return { ...state, team_a_mapping: null, team_b_mapping: null };
    case RETURN_PLAYER_MATCH_MAPPING_ERROR:
      return {
        ...state,
        team_a_mapping_error: action.payload,
        team_b_mapping_error: action.payload,
      };
    default:
      return state;
  }
};
